import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "../../contact/contact.css";
import { Modal } from "@material-ui/core";
import { MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import {
  Box,
  Button as MuiButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import {
  glassDialogPaperProps,
  glassDialogBackdropProps,
  GLASS_DIALOG_TITLE_SX,
  GLASS_PANEL_SX,
} from "./consultationsGlassDialog";
import Multiselect from "multiselect-react-dropdown";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { RotatingLines } from "react-loader-spinner";
import { getUserProfile, allConsultation } from "../../../config/service";
import profile from "../../../assets/images/dashboard/docProfile.png";

/** Stronger frosted paper for this dialog only (merged in ProfileDetailsShell). */
const PROFILE_GLASS_DIALOG_PAPER_EXTRA = {
  borderRadius: "22px",
  border: "1px solid rgba(255, 255, 255, 0.52)",
  background:
    "linear-gradient(155deg, rgba(255,255,255,0.78) 0%, rgba(255,255,255,0.52) 100%)",
  backdropFilter: "blur(24px) saturate(1.28)",
  WebkitBackdropFilter: "blur(24px) saturate(1.28)",
  boxShadow:
    "0 20px 48px rgba(15, 23, 42, 0.14), inset 0 1px 0 rgba(255,255,255,0.72)",
};

/** Overrides global contact.css `.textcenter` / `.text` so labels + values align in RTL/LTR. */
const PROFILE_GLASS_FORM_SX = {
  "& form": {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    gap: 0,
    width: "100%",
  },
  "& .form-group": {
    mb: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "6px",
    marginBottom: "12px !important",
  },
  "& .form-label": {
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: "rgba(49, 46, 129, 0.88)",
    marginBottom: "0 !important",
    letterSpacing: "0.02em",
    textAlign: "start",
    width: "100%",
  },
  "& .form-control": {
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.55) !important",
    background: "rgba(255, 255, 255, 0.42) !important",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.45)",
    marginBottom: "0 !important",
    width: "100%",
    textAlign: "start !important",
    color: "rgba(15, 23, 42, 0.92) !important",
  },
  "& .form-control.textcenter": {
    textAlign: "start !important",
  },
  "& select.form-control.text": {
    textAlign: "start !important",
    color: "rgba(15, 23, 42, 0.92) !important",
  },
  "& .phone-form, & .number-form": { width: "100% !important" },
  "& .multiselect-container": {
    borderRadius: "14px",
    border: "1px solid rgba(255, 255, 255, 0.5) !important",
    background: "rgba(255, 255, 255, 0.38) !important",
    backdropFilter: "blur(12px)",
    minHeight: "44px",
  },
  "& .multiselect-container .search-wrapper": {
    border: "none",
    background: "transparent",
  },
  "& .check": {
    display: "flex",
    alignItems: "center",
    py: 0.75,
    borderRadius: "12px",
    px: 1,
    background: "rgba(255,255,255,0.28)",
    border: "1px solid rgba(255,255,255,0.35)",
    mb: 1,
  },
  "& .team-profile-img": {
    marginBottom: 1.5,
    marginInline: "auto",
    width: "fit-content",
  },
  "& textarea.form-control": {
    minHeight: "72px",
    borderRadius: "12px !important",
    textAlign: "start !important",
  },
  "& .team-profile-img img": {
    border: "3px solid rgba(255,255,255,0.65) !important",
    boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
  },
};

const GLASS_PROFILE_ROOT_SX = {
  width: "100%",
  maxWidth: "100%",
};

const GLASS_SECTION_HEADER_SX = {
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: "rgba(49, 46, 129, 0.82)",
  mt: 0,
  mb: 1.25,
  pb: 0.75,
  textAlign: "start",
  borderBottom: "1px solid rgba(255,255,255,0.45)",
};

/** Tighter title; less air above first panel */
const PROFILE_GLASS_DIALOG_TITLE_SX = {
  ...GLASS_DIALOG_TITLE_SX,
  pt: 2,
  pb: 0.75,
  px: { xs: 2, sm: 2.5 },
};

const PROFILE_GLASS_DIALOG_SX = {
  "& .MuiDialog-container": {
    alignItems: "center",
  },
  "& .MuiDialog-paper": {
    display: "flex",
    flexDirection: "column",
    maxHeight: "min(92dvh, 920px)",
    margin: { xs: 2, sm: 3 },
    overflow: "hidden",
  },
};

function ProfileGlassSection({ enabled, children }) {
  if (enabled) {
    return (
      <Box
        sx={{
          ...GLASS_PANEL_SX,
          p: { xs: 1.5, sm: 2 },
          border: "1px solid rgba(255,255,255,0.42)",
          background:
            "linear-gradient(165deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.18) 100%)",
          boxShadow:
            "0 8px 32px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.5)",
        }}
      >
        {children}
      </Box>
    );
  }
  return <>{children}</>;
}

const GLASS_CLOSE_BTN_SX = {
  borderRadius: "999px",
  px: 3.25,
  py: 1.1,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9375rem",
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.72), rgba(255,255,255,0.42))",
  border: "1px solid rgba(255,255,255,0.55)",
  color: "rgba(49, 46, 129, 0.95)",
  boxShadow: "0 10px 24px rgba(15,23,42,0.1)",
  backdropFilter: "blur(10px)",
  "&:hover": {
    background: "rgba(255,255,255,0.58)",
    border: "1px solid rgba(255,255,255,0.65)",
  },
};

/** Consultations route: Stack + spacing. Else: legacy Bootstrap shell (meetings, etc.). */
function ProfileDetailsBodyLayout({ consultationsGlass, children, closeButton }) {
  if (consultationsGlass) {
    return (
      <Stack spacing={1.5} sx={GLASS_PROFILE_ROOT_SX}>
        {children}
        {closeButton}
      </Stack>
    );
  }
  return (
    <div className="container ">
      <div className="row ">
        <div className="col-md-12">
          <div className="contact-form ">
            <div className="contact-form-content">
              <div>
                <div>
                  {children}
                  {closeButton}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * @param {boolean} [consultationsGlass] — when true (Consultations page only), use MUI liquid-glass dialog.
 */
function ProfileDetailsShell({
  consultationsGlass,
  open,
  onClose,
  title,
  children,
  lang,
}) {
  if (consultationsGlass) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        dir={lang === "HE" ? "rtl" : "ltr"}
        fullWidth
        maxWidth="md"
        scroll="paper"
        sx={PROFILE_GLASS_DIALOG_SX}
        PaperProps={glassDialogPaperProps(PROFILE_GLASS_DIALOG_PAPER_EXTRA)}
        BackdropProps={glassDialogBackdropProps({
          backgroundColor: "rgba(15, 23, 42, 0.42)",
          backdropFilter: "blur(12px)",
        })}
        aria-labelledby="profile-details-glass-title"
      >
        <DialogTitle id="profile-details-glass-title" sx={PROFILE_GLASS_DIALOG_TITLE_SX}>
          {title}
        </DialogTitle>
        <DialogContent
          sx={{
            pt: 0.5,
            pb: 2,
            px: { xs: 2, sm: 2.5 },
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <Box sx={PROFILE_GLASS_FORM_SX}>{children}</Box>
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="imagecropmodal"
    >
      <MDBCard className="modal_card">
        <MDBCardBody>{children}</MDBCardBody>
      </MDBCard>
    </Modal>
  );
}

const ProfileDetails = ({
  detailsopen,
  role,
  userid,
  handleDetailsClose,
  consultationsGlass = false,
}) => {
  const { t } = useTranslation();
  let lang = localStorage.getItem("lang");
  const [show, setShow] = useState(false);
  const [profileDetails, setProfileDetails] = useState();
  const [terms, setTerms] = useState(false);
  const [consent, setConsent] = useState(false);
  const patienttype = [
    { eng: "Children", heb: "ילד.ה" },
    { eng: "Adults", heb: "מבוגר" },
  ];
  const [consultData, setConsultData] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedtype, setSelectedType] = useState([]);
  const [id, setSelectId] = useState([]);
  const [typevalue, setTypeValue] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [doctorData, setDoctorData] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserDetails();
    setShow(profileDetails?.isFromIsrael);
    setTerms(profileDetails?.termsAndConditions);
  }, [detailsopen]);

  useEffect(() => {
    if (role === "doctor") {
      consultingFields();
    }
  }, [role]);


  const handleCloseModal = () => {
    handleDetailsClose()
    setProfileDetails();
  }
  const getUserDetails = async () => {
    setLoading(true);
    try {
      const data = {
        userId: userid,
      };

      const response = await getUserProfile(data);

      if (role === "client") {
        setProfileDetails(response.data.profileDetails[0]);
        setTerms(response?.data?.profileDetails?.termsAndConditions);
        setShow(response?.data?.profileDetails?.isFromIsrael);
        setConsent(response?.data?.profileDetails?.insuranceConsent);
        setProfileImage(response.data.profileDetails?.croppedAvatar);
      } else {
        setProfileDetails(response.data.profileDetails[0]);
        setTerms(response?.data?.profileDetails[0].termsAndConditions);
        setShow(response?.data?.profileDetails[0].isFromIsrael);
        setProfileImage(
          response.data.profileDetails[0].croppedAvatar
            ? response.data.profileDetails[0].croppedAvatar
            : profile
        );
        setDoctorData(response.data.profileDetails[0].doctorData[0]);
        setSelectedValue(response.data.consultationNames);
        setSelectedType(
          response.data?.profileDetails[0]?.doctorData[0]?.patientsCategory.map(
            (d) => {
              return { eng: d, heb: d === "Children" ? "ילד.ה" : "מבוגר" };
            }
          )
        );
        setSelectId(
          response.data?.profileDetails[0]?.doctorData[0]
            ?.consultationSpeciality
        );
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  const onSelect = (selectedList, selectedItem) => {
    setSelectedValue([...selectedValue, selectedItem]);
    setSelectId([...id, selectedItem._id]);
  };

  const onRemove = (selectedList, removedItem) => {
    setSelectedValue(
      selectedValue.filter((d) => {
        return d != removedItem;
      })
    );
    setSelectId(
      id.filter((d) => {
        return d != removedItem._id;
      })
    );
  };

  const onSelectType = (selectedList, selectedItem) => {
    setSelectedType([...selectedtype, selectedItem]);
    setTypeValue([...typevalue, selectedItem.eng]);
  };

  const onRemoveType = (selectedList, removedItem) => {
    setSelectedType(
      selectedtype.filter((d) => {
        return d != removedItem;
      })
    );
    setTypeValue(
      typevalue.filter((d) => {
        return d != removedItem.eng;
      })
    );
  };

  const consultingFields = async () => {
    const response = await allConsultation();
    setConsultData(response.data.result);
  };

  $("#rsd__select-day option:first-child").text(t("Day"));
  $("#rsd__select-month option:first-child").text(t("Month"));
  $("#rsd__select-year option:first-child").text(t("Year"));

  return (
    <ProfileDetailsShell
      consultationsGlass={consultationsGlass}
      open={detailsopen}
      onClose={handleCloseModal}
      title={t("Personal Information")}
      lang={lang}
    >
          <ProfileDetailsBodyLayout
            consultationsGlass={consultationsGlass}
            closeButton={
              consultationsGlass ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    pt: 0.5,
                  }}
                >
                  <MuiButton
                    type="button"
                    variant="contained"
                    disableElevation
                    onClick={handleCloseModal}
                    sx={GLASS_CLOSE_BTN_SX}
                  >
                    {t("Close")}
                  </MuiButton>
                </Box>
              ) : (
                <Button type="submit" onClick={handleCloseModal}>
                  {" "}
                  {t("Close")}
                </Button>
              )
            }
          >
            {!consultationsGlass ? (
              <h2> {t("Personal Information")}</h2>
            ) : null}
            {loading ? (
              consultationsGlass ? (
                <Box
                  sx={{
                    ...GLASS_PANEL_SX,
                    minHeight: 240,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RotatingLines
                    strokeColor="grey"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width="96"
                    visible={loading}
                  />
                </Box>
              ) : (
                <div className="col-md-12">
                  <div
                    style={{
                      height: "90vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <RotatingLines
                      strokeColor="grey"
                      strokeWidth="5"
                      animationDuration="0.75"
                      width="96"
                      visible={loading}
                    />
                  </div>
                </div>
              )
            ) : (
              <>
                <ProfileGlassSection enabled={consultationsGlass}>
                  {role === "doctor" && (
                              <div className="team-profile-img">
                                <img
                                  src={profileImage ? profileImage : ""}
                                  alt=""
                                />
                              </div>
                            )}
                            <Form>
                              <Form.Group className="form-group ">
                                <Form.Label>{t("First Name")}</Form.Label>
                                <input
                                  className="form-control"
                                  name="firstname"
                                  type="text"
                                  readOnly={true}
                                  id="firstname"
                                  value={
                                    profileDetails ? profileDetails.first_name : ""
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="form-group">
                                <Form.Label>{t("Last Name")} </Form.Label>
                                <input
                                  className="form-control"
                                  name="lastname"
                                  type="text"
                                  readOnly={true}
                                  id="lastname"
                                  value={
                                    profileDetails ? profileDetails.last_name : ""
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="form-group">
                                <Form.Label>{t("Email")} </Form.Label>
                                <input
                                  className="form-control forceLtrInput"
                                  name="email"
                                  type="text"
                                  readOnly={true}
                                  id="email"
                                  value={profileDetails ? profileDetails.email : ""}
                                />
                              </Form.Group>

                              <Form.Group className="form-group">
                                <Form.Label>{t("Mobile Number")}</Form.Label>
                                <input
                                  className="form-control forceLtrInput phone_number"
                                  name="mobile_number"
                                  type="text"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  id="mobile_number"
                                  value={profileDetails ? profileDetails.phone : ""}
                                />
                              </Form.Group>

                              <Form.Group className="form-group">
                                <Form.Label>
                                  {profileDetails?.passportNumber
                                    ? t("Passport")
                                    : t("ID Number")}{" "}
                                </Form.Label>
                                <input
                                  className="form-control textcenter"
                                  name="id"
                                  type="text"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  onWheel={(e) => e.target.blur()}
                                  id="id"
                                  value={
                                    profileDetails ? profileDetails.id : ""
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="form-group">
                                <Form.Label>{t("Date of Birth")} </Form.Label>
                                {profileDetails && (
                                  <input
                                    className="form-control textcenter"
                                    name="clientDOB"
                                    type="text"
                                    readOnly={true}
                                    value={
                                      profileDetails?.clientDOB
                                        ? new Date(profileDetails.clientDOB).toLocaleDateString("en-GB")
                                        : ""
                                    }
                                  />
                                )}
                              </Form.Group>
                              <Form.Group className="form-group">
                                <Form.Label>{t("Gender")} </Form.Label>
                                {profileDetails && (
                                  <select
                                    className="form-control text"
                                    name="clientGender"
                                    readOnly={true}
                                    value={profileDetails?.clientGender}
                                  >
                                    <option>{t("Select")}</option>
                                    <option value="Male">{t("Male")}</option>
                                    <option value="Female">
                                      {t("Female")}
                                    </option>
                                  </select>
                                )}
                              </Form.Group>
                              {profileDetails?.personalId ? (
                                <Form.Group className="form-group">
                                  <Form.Label>
                                    {t("Personal ID Number")}{" "}
                                  </Form.Label>
                                  <input
                                    className="form-control textcenter"
                                    name="personalId"
                                    type="text"
                                    readOnly={true}
                                    onWheel={(e) => e.target.blur()}
                                    id="personalId"
                                    value={
                                      profileDetails?.personalId
                                        ? profileDetails?.personalId
                                        : ""
                                    }
                                  />
                                </Form.Group>
                              ) : null}
                              {role === "doctor" ? null : (
                                <Form.Group className="form-group">
                                  <Form.Label>{t("Marital Status")}</Form.Label>
                                  {profileDetails && (
                                    <select
                                      className="form-control text"
                                      name="MaritalStatus"
                                      value={
                                        profileDetails?.clientMaritalStatus
                                      }
                                      readOnly={true}
                                    >
                                      <option>{t("Select")}</option>
                                      <option value="Married">
                                        {t("Married")}
                                      </option>
                                      <option value="Single">
                                        {t("Single")}
                                      </option>
                                      <option value="Divorced">
                                        {t("Divorced")}
                                      </option>
                                    </select>
                                  )}
                                </Form.Group>
                              )}
                              {role === "doctor" &&
                                doctorData &&
                                doctorData.doctorId ? (
                                <>
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      {t("Doctor license")}
                                    </Form.Label>
                                    <input
                                      className="form-control"
                                      name="doctor_license"
                                      type="number"
                                      // value={formValue.phoneNumber}
                                      readOnly={true}
                                      id="doctor_license"
                                      value={
                                        doctorData
                                          ? doctorData.licenceNumber
                                          : ""
                                      }
                                    />
                                  </Form.Group>
                                  <Form.Group className="form-group">
                                    <Form.Label>{t("Title")}</Form.Label>
                                    <select
                                      className="form-control"
                                      name="title"
                                      readOnly={true}
                                      value={doctorData ? doctorData.title : ""}
                                    >
                                      <option value="Professor">
                                        {t("Professor")}
                                      </option>
                                      <option value="Doctor">
                                        {t("Doctor")}
                                      </option>
                                    </select>
                                  </Form.Group>
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      {t("Specilization")}{" "}
                                    </Form.Label>
                                    <Multiselect
                                      className="form-control"
                                      options={consultData}
                                      selectedValues={selectedValue}
                                      onSelect={onSelect}
                                      onRemove={onRemove}
                                      displayValue={
                                        lang === "EN" ? "eng" : "heb"
                                      }
                                      placeholder=""
                                      id="consult"
                                    />
                                  </Form.Group>
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      {t("Patient Type")}{" "}
                                    </Form.Label>
                                    <Multiselect
                                      className="form-control"
                                      options={patienttype}
                                      selectedValues={selectedtype}
                                      onSelect={onSelectType}
                                      onRemove={onRemoveType}
                                      displayValue={
                                        lang === "EN" ? "eng" : "heb"
                                      }
                                      placeholder=""
                                    />
                                  </Form.Group>
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      {t("Practice")} / {t("Experience")}
                                    </Form.Label>
                                    <input
                                      className="form-control"
                                      name="experience"
                                      type="text"
                                      // value={formValue.phoneNumber}
                                      readOnly={true}
                                      id="experience"
                                      value={
                                        doctorData ? doctorData.experience : ""
                                      }
                                    />
                                  </Form.Group>
                                  <Form.Group className="form-group">
                                    <Form.Label>{t("Bio")}</Form.Label>
                                    <textarea
                                      className="form-control"
                                      maxlength="300"
                                      name="bio"
                                      type="text"
                                      // value={formValue.phoneNumber}
                                      readOnly={true}
                                      id="bio"
                                      value={doctorData ? doctorData.bio : ""}
                                    />
                                  </Form.Group>
                                </>
                              ) : null}
                            </Form>
                </ProfileGlassSection>
                            {consultationsGlass ? (
                              <Typography
                                component="h2"
                                sx={GLASS_SECTION_HEADER_SX}
                              >
                                {t("Address")}
                              </Typography>
                            ) : (
                              <h2> {t("Address")}</h2>
                            )}
                <ProfileGlassSection enabled={consultationsGlass}>
                            <Form className="form" id="b">
                              <div className="check" id="check">
                                <input
                                  type="checkbox"
                                  defaultChecked={show}
                                  onClick={() => setShow(!show)}
                                />
                                <span> {t("I do not live in Israel")}</span>
                              </div>
                              {show ? (
                                <>
                                  <Form.Group className="form-group">
                                    <Form.Label>{t("Country")} </Form.Label>
                                    <input
                                      className="form-control"
                                      name="country"
                                      type="text"
                                      id="country"
                                      readOnly={true}
                                      value={
                                        profileDetails &&
                                          profileDetails.clientAddress
                                          ? profileDetails?.clientAddress
                                            ?.country
                                          : ""
                                      }
                                    />
                                  </Form.Group>

                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      {t(
                                        "Local phone number (including area code and plus sign +)"
                                      )}
                                    </Form.Label>
                                    <input
                                      className="form-control"
                                      name="localphoneNumber"
                                      type="tel"
                                      // value={formValue.phoneNumber}
                                      readOnly={true}
                                      id="localphoneNumber"
                                      value={
                                        profileDetails &&
                                          profileDetails.clientAddress
                                          ? profileDetails.clientAddress
                                            .localPhone
                                          : ""
                                      }
                                    />
                                  </Form.Group>
                                </>
                              ) : (
                                ""
                              )}

                              <Form.Group className="phone-form">
                                <Form.Label>{t("Street")}</Form.Label>
                                <input
                                  className="form-control"
                                  name="street"
                                  type="text"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  id="street"
                                  value={
                                    profileDetails &&
                                      profileDetails.clientAddress
                                      ? profileDetails.clientAddress.street
                                      : ""
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="number-form">
                                <Form.Label>{t("House No")}</Form.Label>
                                <input
                                  className="form-control"
                                  name="houseNo"
                                  type="text"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  id="houseNo"
                                  value={
                                    profileDetails &&
                                      profileDetails.clientAddress
                                      ? profileDetails.clientAddress.house
                                      : ""
                                  }
                                />
                              </Form.Group>

                              <Form.Group className="phone-form">
                                <Form.Label>{t("City")}</Form.Label>
                                <input
                                  className="form-control"
                                  name="city"
                                  type="text"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  id="city"
                                  value={
                                    profileDetails &&
                                      profileDetails.clientAddress
                                      ? profileDetails.clientAddress.city
                                      : ""
                                  }
                                />
                              </Form.Group>
                              <Form.Group className="number-form">
                                <Form.Label>{t("Postal Code")}</Form.Label>
                                <input
                                  className="form-control"
                                  name="postalcode"
                                  type="tel"
                                  // value={formValue.phoneNumber}
                                  readOnly={true}
                                  id="postalcode"
                                  dir="auto"
                                  value={
                                    profileDetails &&
                                      profileDetails.clientAddress
                                      ? profileDetails.clientAddress.pincode
                                      : ""
                                  }
                                />
                              </Form.Group>
                              {role === "client" && (
                                <>
                                  <div className="check">
                                    <input
                                      type="checkbox"
                                      checked={consent}
                                      onClick={() => setConsent(!consent)}
                                    />
                                    <span>
                                      {" "}
                                      {t("I agree to the insurance consent")}
                                    </span>
                                  </div>
                                  <div className="check">
                                    <input
                                      type="checkbox"
                                      checked={terms}
                                      onClick={() => setTerms(!terms)}
                                    />
                                    <span>
                                      {" "}
                                      {t("I agree to the site term's of use")}
                                    </span>
                                  </div>
                                </>
                              )}
                            </Form>
                </ProfileGlassSection>
                          </>
                        )}
          </ProfileDetailsBodyLayout>
    </ProfileDetailsShell>
  );
};

export default ProfileDetails;
